import React from "react"
import { Outlet } from "react-router-dom"
import { Navigation } from "widgets/navigation"
import styles from "./main-loyout.module.css"
import { NavigationMobile } from "widgets/navigation-mobile"

export const MainLoyout = () => {
    return (
        <div className={styles.App}>
            <Navigation/>
            <NavigationMobile/>
            <Outlet/>
        </div>
    )
}